import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

// ----------------------------
// ACTION TYPES
// ----------------------------
export const FETCH_PROFILE_REQUEST = "FETCH_PROFILE_REQUEST";
export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";
export const FETCH_PROFILE_FAIL = "FETCH_PROFILE_FAIL";

// ----------------------------
// FETCH USER PROFILE
// ----------------------------
export const fetchUserProfile = (uid) => async (dispatch) => {
  dispatch({ type: FETCH_PROFILE_REQUEST });

  try {
    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      throw new Error("User profile not found");
    }

    const profileData = {
      id: snap.id,
      ...snap.data(),
    };

    dispatch({
      type: FETCH_PROFILE_SUCCESS,
      payload: profileData,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PROFILE_FAIL,
      payload: error.message,
    });
  }
};